// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__jnOM-","alertIcon":"ConfirmModal_alertIcon__2Mt--"};